import { _form } from './_form';

export const challengesEdit = () => {
  _form();
};
